// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"db742f11","773":"a7925002"}[chunkId] + ".chunk.js";
};